import { useEffect } from 'react';

const usePageTitle = (title, description) => {
  useEffect(() => {
    const baseTitle = 'Advanta Plus';
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;
    
    // Update meta description if provided
    if (description) {
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute('content', description);
      }
    }
    
    return () => {
      document.title = 'Advanta Plus | Premium Travel Membership - Costa del Sol';
    };
  }, [title, description]);
};

export default usePageTitle;
